var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeTrackerPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4232",
    "data-name": "Group 4232",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_143",
    "data-name": "Polygon 143",
    d: "M2.5,1.549a1,1,0,0,1,1.743,0L5.912,4.51A1,1,0,0,1,5.04,6H1.71A1,1,0,0,1,.838,4.51Z",
    transform: "translate(12 5) rotate(90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTrackerPlay);
export default __webpack_public_path__ + "static/media/time-tracker-play.653842c8bd0bab74fa5b70ee6a720506.svg";
export { ForwardRef as ReactComponent };